export default __webpack_public_path__ + "static/media/Christmas_19.432ecd17.png";